var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.048 0.287994V18.848L9.024 28.768C8.81067 30.1333 8.40533 31.2 7.808 31.968C7.25333 32.6933 6.336 33.056 5.056 33.056C3.904 33.056 3.008 32.6933 2.368 31.968C1.77067 31.2 1.36533 30.1333 1.152 28.768L0.128 18.848V0.287994H10.048ZM31.36 0.287994V18.848L30.336 28.768C30.1227 30.1333 29.7173 31.2 29.12 31.968C28.5653 32.6933 27.648 33.056 26.368 33.056C25.216 33.056 24.32 32.6933 23.68 31.968C23.0827 31.2 22.6773 30.1333 22.464 28.768L21.44 18.848V0.287994H31.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoDots);
export default __webpack_public_path__ + "static/media/twoDots.e22d5335b978ad6e05393ab35dcdcaa7.svg";
export { ForwardRef as ReactComponent };